import React from 'react';
import PropTypes from 'prop-types';
import HorizontalScroll from '../Global/Containers/HorizontalScroll';
import ContentTeaser from '../Global/Teasers/ContentTeaser';
import NoResultsMessage from '../Global/Messages/NoResultsMessage';
import CuratedFavouritesAuthor from './CuratedFavouritesAuthor';
import SectionHeading from '../Global/Typography/SectionHeading';

const CuratedFavourites = ({ data, loading, loggedInUser, doIFollowCurator, onFollowClick }) => {
  const listItemClass = `training-ground-curated-favourites__list-item col-md-6 col-xl-3`;

  let curatedFavouritesList;
  if (data && data.content && data.content.length > 0) {
    const authorFormattedForUserCard = {
      bio: data.author.bio,
      the_real_deal: true,
      image_url: data.author.image_url,
      full_name: `${data.author.full_name}`,
      id: data.author.id,
    };

    curatedFavouritesList = (
      <HorizontalScroll grid>
        <ul className="row">
          <li className={listItemClass}>
            <CuratedFavouritesAuthor
              author={authorFormattedForUserCard}
              message={data.summary}
              loggedInUser={loggedInUser}
              classes="box-shadow-l"
              doIFollowCurator={doIFollowCurator}
              onFollowClick={onFollowClick}
            />
          </li>

          {data.content.slice(0, 3).map((listItem) => {
            const { id, slug, title, plaintext_summary, author_full_name, type, tcm_age_range, usa_age_range, hero_image_url, is_new, has_video, stream_image_url } = listItem;
            return (
              <li key={id} className={listItemClass}>
                <ContentTeaser
                  href={slug}
                  title={title}
                  summary={plaintext_summary}
                  authorName={author_full_name}
                  type={type}
                  tcmAgeRange={tcm_age_range}
                  usaAgeRange={usa_age_range}
                  userLocation={loggedInUser.userLocation}
                  heroImage={hero_image_url}
                  streamImage={stream_image_url.M}
                  isNew={is_new}
                  hasVideo={has_video}
                  showImage
                  classes="content-teaser-new--card box-shadow-l"
                />
              </li>
            );
          })}
        </ul>
      </HorizontalScroll>
    );
  } else {
    curatedFavouritesList = (
      <NoResultsMessage
        title="No favourites available"
        loading={loading}
        border
      />
    );
  }

  return (
    <div className="training-ground-curated-favourites">
      <SectionHeading
        title="Our Favourites for this week"
        subtitle="Handpicked for your age group by a member of our community each week"
      />
      {curatedFavouritesList}
    </div>
  );
};

CuratedFavourites.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  loggedInUser: PropTypes.object,
  doIFollowCurator: PropTypes.array.isRequired,
  onFollowClick: PropTypes.func.isRequired,
};

export default CuratedFavourites;



// WEBPACK FOOTER //
// ./library/app/components/TrainingGround/CuratedFavourites.js